// Force scroll to start at top of page on refresh
class StickyForm extends HTMLElement {
  constructor() {
    super();
  }

  els() {
    this.pdpEl = document.querySelector('product-detail');
    this.pdpBtnEl = this.pdpEl?.querySelector('[data-product-add-to-cart]');
  }

  pauseUnsubscriber = undefined;
  startUnsubscriber = undefined;
  updateUnsubscriber = undefined;

  connectedCallback() {
    this.els();
    this.io();

    this.pauseUnsubscriber = window.subscribe(PUB_SUB_EVENTS.stickyFormPause, () => {
      document.documentElement.classList.remove('sticky-form--show');
      this.observer.disconnect();
    });

    this.startUnsubscriber = window.subscribe(PUB_SUB_EVENTS.stickyFormStart, () => {
      this.els();
      this.observer.observe(this.pdpBtnEl);
    });

    this.updateUnsubscriber = window.subscribe(PUB_SUB_EVENTS.stickyFormUpdate, () => {
      this.updateForm();
    });

    if (this.dataset.mobileAtcText && window.innerWidth < 1024) {
      const atcBtn = this.querySelector('[data-product-add-to-cart]')
      if (atcBtn) atcBtn.innerText = this.dataset.mobileAtcText;
    }
  }

  disconnectedCallback() {
    const unsubscribers = [
      this.pauseUnsubscriber,
      this.startUnsubscriber,
    ];

    unsubscribers.forEach(pauseUnsubscriber => pauseUnsubscriber && pauseUnsubscriber());
  }

  io() {
    if (!this.pdpBtnEl) return;

    const callback = entries => {
      entries.forEach(entry => {
        document.documentElement.classList[entry.isIntersecting ? 'remove' : 'add']('sticky-form--show');
      });
    };

    this.observer = new IntersectionObserver(callback, {});
    this.observer.observe(this.pdpBtnEl);
  }

  updateForm() {
    // update form id to match current variant on pdp
    const form = this.querySelector('form');
    const pdpForm = this.pdpEl?.querySelector('form');
    if (!form || !pdpForm) return;

    form.querySelector('[name="id"]').value = pdpForm.querySelector('[name="id"]').value;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('sticky-form')) {
    customElements.define('sticky-form', StickyForm);
  }
});
